import React, { useEffect } from 'react';
import { SeoBar } from '../components/SeoBar';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import { HeroSection } from './machining-center-roi/HeroSection';
import { IntroSection } from './machining-center-roi/IntroSection';
import { AcquisitionCostsSection } from './machining-center-roi/AcquisitionCostsSection';
import { OperationCostsSection } from './machining-center-roi/OperationCostsSection';
import { MaintenanceCostsSection } from './machining-center-roi/MaintenanceCostsSection';
import { DecommissionCostsSection } from './machining-center-roi/DecommissionCostsSection';
import { FooterLinkSection } from './machining-center-roi/FooterLinkSection';
export function MachiningCenterROIPage() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return <div className="min-h-screen w-full bg-white flex flex-col" data-id="element-3292">
      <SeoBar data-id="element-3293" />
      <Header data-id="element-3294" />
      <main className="flex-grow" data-id="element-3295">
        <div className="w-full bg-gray-50 pb-20" data-id="element-3296">
          <HeroSection data-id="element-3297" />
          <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 py-12 space-y-12" data-id="element-3298">
            <IntroSection data-id="element-3299" />
            <AcquisitionCostsSection data-id="element-3300" />
            <OperationCostsSection data-id="element-3301" />
            <MaintenanceCostsSection data-id="element-3302" />
            <DecommissionCostsSection data-id="element-3303" />
            <FooterLinkSection data-id="element-3304" />
          </div>
        </div>
      </main>
      <Footer data-id="element-3305" />
    </div>;
}